import { HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { Capacitor } from '@capacitor/core';

export const AUTH_COOKIE_SESSION: InjectionToken<boolean> = new InjectionToken<boolean>('AUTH_COOKIE_SESSION', {
  providedIn: 'root',
  factory: (): boolean => !Capacitor.isNativePlatform(),
});

export const REPLAY_REQUEST_AFTER_TOKEN_REFRESH: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);
